import { useMemo, useRef } from "react";

import Modal from "@mui/material/Modal";
import { HTMLProps, useState } from "react";
import { useTranslation } from "react-i18next";
// libraries
import { Carousel } from "react-responsive-carousel";

// galleryStyles
import galleryStyles from "./gallery.module.scss";
import classNames from "classnames";
import PDFComponent from "../../common/PDFComponent";
import { Draggable } from "../../../setup/util/draggable";

export enum GalleryType {
  DEFAULT = "DEFAULT",
  SMALL = "SMALL",
  LARGE = "LARGE",
}
interface Props extends HTMLProps<HTMLDivElement> {
  type?: GalleryType;
  images: string[];
  header?: string;
  isBrokerContract?: boolean;
  isPreviewGallery?: boolean;
}

const Gallery = ({
  type = GalleryType.DEFAULT,
  images: files,
  header = "",
  isBrokerContract,
  isPreviewGallery,
  ...rest
}: Props) => {
  const mainRef = useRef(null);
  const [showSlider, setShowSlider] = useState(false);
  const [selectedItem, setSelectedItem] = useState(0);

  const { t } = useTranslation();

  const pdfFiles = useMemo(() => {
    return files?.filter((file) => file?.endsWith("pdf"));
  }, [files]);
  const imageFiles = useMemo(() => {
    return files?.filter((file) => !file?.endsWith("pdf"));
  }, [files]);

  if (
    (!imageFiles[0] || imageFiles[0] === "") &&
    (!pdfFiles[0] || pdfFiles[0] === "")
  )
    return null;

  return (
    <div className={galleryStyles["container"]} {...rest}>
      {pdfFiles[0] &&
        pdfFiles[0] !== "" &&
        isBrokerContract &&
        !isPreviewGallery &&
        imageFiles[0] &&
        imageFiles[0] !== "" && (
          <h4
            className={classNames(
              galleryStyles["g900"],
              galleryStyles["title"]
            )}>
            {" "}
            {header ? `${header}` : t("lbl_attachments")}
          </h4>
        )}
      {pdfFiles[0] && pdfFiles[0] !== "" && !isPreviewGallery && (
        <div className={galleryStyles["horizontal_container"]}>
          {pdfFiles?.map((pdf, index) => (
            <PDFComponent
              key={index}
              fileUrl={pdf}
              isPreview={isPreviewGallery}
            />
          ))}
        </div>
      )}
      {!isBrokerContract || isPreviewGallery ? (
        <Draggable innerRef={mainRef} rootClass={"drag"}>
          <div
            className={classNames(
              galleryStyles["form-scroll"],
              {
                [galleryStyles["horizontal_container"]]:
                  isPreviewGallery && isBrokerContract,
              },
              {
                [galleryStyles["preview_container"]]:
                  isPreviewGallery && isBrokerContract,
              }
            )}>
            {imageFiles?.map((image, index) => (
              <>
                {image && image !== "" && (
                  <div
                    key={index}
                    className={galleryStyles["uplaoded_image_container"]}>
                    <img
                      className={classNames(
                        galleryStyles["uploaded_image"],
                        galleryStyles[`${type}`]
                      )}
                      onClick={() => {
                        setSelectedItem(index);
                        setShowSlider(!showSlider);
                      }}
                      src={image}
                      draggable={false}
                    />
                  </div>
                )}
              </>
            ))}
            {isBrokerContract &&
              pdfFiles[0] &&
              pdfFiles[0] !== "" &&
              isPreviewGallery &&
              pdfFiles?.map((pdf, index) => (
                <PDFComponent
                  key={index}
                  fileUrl={pdf}
                  isPreview={isPreviewGallery}
                />
              ))}
          </div>
        </Draggable>
      ) : (
        <div className={galleryStyles["vertical_container"]}>
          {imageFiles.map((image, index) => (
            <img key={index} src={image} />
          ))}
        </div>
      )}
      <Modal
        open={showSlider}
        onClose={() => setShowSlider(!showSlider)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <span className={galleryStyles["container_wrapper_carousel"]}>
          <Carousel
            autoPlay={true}
            showThumbs={false}
            selectedItem={selectedItem}
            showIndicators={true}
            dynamicHeight={true}>
            {imageFiles?.map((image, index) => (
              <div
                className={galleryStyles["container_wrapper_div"]}
                key={index}>
                <img
                  src={image}
                  className={galleryStyles["container_wrapper_img"]}
                  draggable={false}
                />
              </div>
            ))}
          </Carousel>
        </span>
      </Modal>
    </div>
  );
};

export default Gallery;
